import type { ApiResponse } from 'apisauce';
import type { ResponseModel } from '../../shared/interfaces/response-model.interface';
import type { ErrorInfo } from '../../shared/interfaces/error-info.interface';
import type { UserModel } from '../../shared/models/user.model';
import api from '../../shared/services/utils/api/api.service';
import errorHelper from '../../shared/services/utils/api/error-helper.service';
import { getModuleName } from '../../UserModule/shared/services/user.service';

export interface CreateStaffUserPayload {
  name: string;
  email: string;
  phone: string;
  password: string;
  role: string;
}

export function createStaffUser(
  payload: CreateStaffUserPayload
): Promise<UserModel | ErrorInfo> {
  return api
    .createAdminUser(payload)
    .then((response: ApiResponse<ResponseModel<any>, ErrorInfo>) => {
      if (response.ok && response.data?.data) {
        // admin-connect strips the session the authenticator's register hands back, but never
        // pass this straight into anything that writes the admin-token cookie regardless — the
        // account in the response is not the account making the request.
        return response.data.data as UserModel;
      }
      return errorHelper(
        Number(response.status),
        String((response.data as any)?.errorCode || response.problem || ''),
        getModuleName(),
        (api.createAdminUser as any).displayName
      );
    });
}
